import Cookies from 'universal-cookie';
import { useState } from 'react';

export const getIndivCookie = (cookieName: string): string => {
    const cookies = new Cookies();
    return cookies.get(cookieName) || '';
};

export const isLoggedIn = (): boolean => {
    const token = getIndivCookie('cToken');
    return !!token;
};

export const useCookie = (key: string) => {
    const cookies = new Cookies();
    const [item, setItemValue] = useState(() => {
        if (cookies.get(key)) {
            return cookies.get(key);
        }
        return null;
    });

    const setValue = (value: string) => {
        setItemValue(value);
        const date = new Date();
        date.setTime(date.getTime() + (20 * 60 * 1000));
        cookies.set(key, value, { expires: date });
    };
    return [item, setValue];
};

export const deleteCookie = (key: string) => {
    const cookies = new Cookies();
    cookies.remove(key);
};